import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import * as R from "ramda";
import { format } from "date-fns";

import { DateWithModal } from "../../../_common/dateWithModal";

export const AidavieFilter = ({ creationUsersOptions, searchRef, pageSearch, setPageSearch, routerQuery, operatorId, pageQuery, teleconseillers, userId }) => {
	const history = useHistory();

	const operatorIdParam = pageQuery.get("operatorId");

	const [date, setDate] = useState({ startDate: routerQuery.fromCreationDate ? new Date(routerQuery.fromCreationDate) : undefined, endDate: routerQuery.toCreationDate ? new Date(routerQuery.toCreationDate) : undefined });
	useEffect(() => {}, [teleconseillers]);

	return (
		<nav className="navbar navbar-expand-lg navbar-light px-0 mb-2">
			<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
				<span className="btn-alert-primary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
				<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
			</button>
			<div className="collapse navbar-collapse flex-column" id="navbarNav">
				<form className="form-inline container-default mx-auto justify-content-center" id="filterForm" onSubmit={(e) => e.preventDefault()}>
					<div className={"my-1 input-group btn-dim rounded-max mr-2 ml-xl-auto" + (pageSearch !== "" ? " active" : "")}>
						<input type="text" className="form-control bg-none rounded-inherit border-none no-focus shadow-none" placeholder="Recherche" ref={searchRef} aria-label="Recherche" value={pageSearch} onChange={(e) => setPageSearch(e.target.value)} />
						<div className="input-group-prepend rounded-inherit">
							<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4">
								<i className="eva eva-search-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
							</button>
						</div>
					</div>

					<DateWithModal
						selectedDate={date.startDate}
						setSelectedDate={(dateCalendar) => {
							setDate({ ...date, startDate: dateCalendar });
							const searchParams = new URLSearchParams(window.location.search);
							searchParams.set("fromCreationDate", format(dateCalendar, "yyyy-MM-dd"));
							history.push(`/backoffice/aidavie?${searchParams}`);
						}}
						isRequired={true}
						classToolbar={true}
						maxDate={new Date().setFullYear(new Date().getFullYear() + 5)}
					/>
					<div className="d-inherit mx-2 text-gray">-</div>
					<DateWithModal
						selectedDate={date.endDate}
						setSelectedDate={(dateCalendar) => {
							setDate({ ...date, endDate: dateCalendar });
							const searchParams = new URLSearchParams(window.location.search);
							searchParams.set("toCreationDate", format(dateCalendar, "yyyy-MM-dd"));
							history.push(`/backoffice/aidavie?${searchParams}`);
						}}
						isRequired={true}
						classToolbar={true}
						maxDate={new Date().setFullYear(new Date().getFullYear() + 5)}
					/>

					<div className={"my-1 input-group btn-dim rounded-max mx-2 btn-alert active"} role="button">
						<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							{routerQuery.sortBy === "LastName" ? "Ordre alphabétique" : "Les plus récents"}
						</p>
						<div className="input-group-prepend rounded-inherit dropdown">
							<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<i className="eva eva-funnel-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
							</button>
							<div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="dropdownMenuButton">
								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.sortBy === "CreationDate" ? "active" : "")}
									to={() => {
										const searchParams = new URLSearchParams(window.location.search);
										searchParams.set("sortBy", "CreationDate");
										searchParams.set("sortDesc", "true");
										return `/backoffice/aidavie?${searchParams}`;
									}}
									type="button">
									Les plus récents
								</Link>
								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.sortBy === "LastName" ? "active" : "")}
									to={() => {
										const searchParams = new URLSearchParams(window.location.search);
										searchParams.set("sortBy", "LastName");
										searchParams.set("sortDesc", "false");
										return `/backoffice/aidavie?${searchParams}`;
									}}
									type="button">
									Ordre alphabétique
								</Link>
							</div>
						</div>
					</div>
				</form>
			</div>
			<span className="small font-weight-bold">
				Besoin d'aide ?{" "}
				<a className="text-info" href="/faqs">
					FAQ
				</a>
			</span>
		</nav>
	);
};
